module.exports = {
  ACTIVATION_STATUS: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    TEMPORARY_BLOCKED: 'TEMPORARY_BLOCKED',
    PERMANENTLY_BLOCKED: 'PERMANENTLY_BLOCKED'
  }
};
